"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.MAX_AUDIO_LEVEL = exports.LEVEL_MULTIPLIER = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));
var _mobx = require("mobx");
var _utils = require("@seedlang/utils");
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18;
var MAX_AUDIO_LEVEL = exports.MAX_AUDIO_LEVEL = 100;
var LEVEL_MULTIPLIER = exports.LEVEL_MULTIPLIER = 230;
var BaseUserInputStore = (_class = /*#__PURE__*/function () {
  function BaseUserInputStore() {
    var _this = this;
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck2["default"])(this, BaseUserInputStore);
    (0, _initializerDefineProperty2["default"])(this, "isRecording", _descriptor, this);
    (0, _initializerDefineProperty2["default"])(this, "mediaType", _descriptor2, this);
    (0, _initializerDefineProperty2["default"])(this, "audioLevel", _descriptor3, this);
    (0, _initializerDefineProperty2["default"])(this, "maxAudioLevel", _descriptor4, this);
    (0, _initializerDefineProperty2["default"])(this, "secondsElapsed", _descriptor5, this);
    (0, _initializerDefineProperty2["default"])(this, "startRecordingTimestamp", _descriptor6, this);
    (0, _initializerDefineProperty2["default"])(this, "endRecordingTimestamp", _descriptor7, this);
    (0, _initializerDefineProperty2["default"])(this, "startPlayingTimestamp", _descriptor8, this);
    (0, _initializerDefineProperty2["default"])(this, "pausePlayingTimestamp", _descriptor9, this);
    (0, _initializerDefineProperty2["default"])(this, "playing", _descriptor0, this);
    (0, _initializerDefineProperty2["default"])(this, "initialPlayHasFinished", _descriptor1, this);
    (0, _initializerDefineProperty2["default"])(this, "currentTime", _descriptor10, this);
    (0, _initializerDefineProperty2["default"])(this, "url", _descriptor11, this);
    (0, _initializerDefineProperty2["default"])(this, "durationFromDatabase", _descriptor12, this);
    (0, _initializerDefineProperty2["default"])(this, "autoPlay", _descriptor13, this);
    (0, _initializerDefineProperty2["default"])(this, "hasFinishedRecording", _descriptor14, this);
    (0, _initializerDefineProperty2["default"])(this, "canRecord", _descriptor15, this);
    (0, _initializerDefineProperty2["default"])(this, "inputType", _descriptor16, this);
    (0, _initializerDefineProperty2["default"])(this, "messageInput", _descriptor17, this);
    (0, _initializerDefineProperty2["default"])(this, "caretPosition", _descriptor18, this);
    this.setInputType = function (inputType) {
      _this.inputType = inputType || '';
    };
    this.insertText = function (text) {
      if (typeof document !== 'undefined') {
        var el = document.getElementById('user-input');
        if (el) {
          var caretPosition = el.selectionStart;
          if (_this.messageInput) {
            var newValue = [_this.messageInput.slice(0, caretPosition), text, _this.messageInput.slice(caretPosition)].join('');
            _this.caretPosition = caretPosition + 1;
            _this.messageInput = newValue;
          } else {
            _this.messageInput = text;
          }
        }
      }
    };
    this.onUpdateMessageInput = function (value) {
      _this.messageInput = value;
      if (typeof document !== 'undefined') {
        var el = document.getElementById('user-input');
        if (el) {
          _this.caretPosition = el.selectionStart;
        }
      }
    };
    this.resetInputState = function () {
      _this.inputType = '';
      _this.messageInput = '';
      _this.caretPosition = null;
    };
    this.set = function (obs, value) {
      _this[obs] = value;
    };
    this.startSecondsElapsed = function () {
      _this.startRecordingTimestamp = +new Date();
      _this.secondsElapsed = 0;
      if (_this.interval) {
        clearInterval(_this.interval);
        _this.interval = null;
      }
      _this.interval = setInterval(function () {
        return _this.secondsElapsed += 1;
      }, 1000);
    };
    this.stopSecondsElapsed = function () {
      _this.endRecordingTimestamp = +new Date();
      if (_this.interval) {
        clearInterval(_this.interval);
        _this.interval = null;
      }
    };
    this.audioPlaybackFinishedCallback = function () {
      _this.playing = false;
      _this.pausePlayingTimestamp = +new Date();
      if (_this.interval) {
        clearInterval(_this.interval);
        _this.interval = null;
      }
    };
    this.onTogglePlay = function () {
      if (typeof console !== 'undefined' && _this.isNative) {
        console.log('[UserInputStore] onTogglePlay', {
          cardId: _this.cardId,
          playing: _this.playing,
          isNative: _this.isNative
        });
      }
      if (_this.playing) {
        _this.pause();
      } else {
        _this.play();
      }
    };
    this.resetRecordingState = function () {
      _this.isRecording = false;
      _this.audioLevel = 0;
      _this.maxAudioLevel = 0;
      _this.startRecordingTimestamp = null;
      _this.endRecordingTimestamp = null;
      _this.startPlayingTimestamp = null;
      _this.pausePlayingTimestamp = null;
      _this.secondsElapsed = 0;
      _this.hasFinishedRecording = false;
      _this.playing = false;
      _this.initialPlayHasFinished = false;
      _this.currentTime = 0;
      if (_this.interval) {
        clearInterval(_this.interval);
        _this.interval = null;
      }
    };
    this.onMediaReset = /*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var _t;
      return _regenerator["default"].wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(typeof _this.stopRecording === 'function')) {
              _context.next = 4;
              break;
            }
            _context.prev = 1;
            _context.next = 2;
            return _this.stopRecording({
              skipCallback: true,
              skipCreateObjectURL: true
            });
          case 2:
            _context.next = 4;
            break;
          case 3:
            _context.prev = 3;
            _t = _context["catch"](1);
          case 4:
            if (typeof _this.onSoftReset === 'function') {
              _this.onSoftReset();
            } else {
              _this.resetRecordingState();
            }
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 3]]);
    }));
    this.onToggleRecordAudio = /*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      return _regenerator["default"].wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!_this.isRecording) {
              _context2.next = 2;
              break;
            }
            if (!(typeof _this.stopRecording === 'function')) {
              _context2.next = 1;
              break;
            }
            _context2.next = 1;
            return _this.stopRecording();
          case 1:
            return _context2.abrupt("return");
          case 2:
            _this.setInputType('audio');
            if (typeof _this.onReset === 'function') {
              _this.onReset();
            }
            if (!(typeof _this.recordAudio === 'function')) {
              _context2.next = 4;
              break;
            }
            _context2.next = 3;
            return _this.recordAudio();
          case 3:
            _context2.next = 5;
            break;
          case 4:
            if (!(typeof _this.startRecording === 'function')) {
              _context2.next = 5;
              break;
            }
            _context2.next = 5;
            return _this.startRecording();
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    this.reset = function () {
      _this.resetInputState();
    };
    this.parent = params.parent;
    this.cardId = params.cardId;
    this.url = params.url || null;
    this.isNative = Boolean(params.isNative);
    if ((0, _utils.isPresent)(params.duration)) {
      this.durationFromDatabase = params.duration;
    }
  }
  return (0, _createClass2["default"])(BaseUserInputStore, [{
    key: "normalizedAudioLevel",
    get: function get() {
      var level = Math.round(this.audioLevel * LEVEL_MULTIPLIER);
      if (level > MAX_AUDIO_LEVEL) {
        level = MAX_AUDIO_LEVEL;
      }
      return level;
    }
  }, {
    key: "duration",
    get: function get() {
      if (this.durationFromDatabase) {
        return this.durationFromDatabase;
      }
      if (this.endRecordingTimestamp && this.startRecordingTimestamp && this.endRecordingTimestamp > 0 && this.startRecordingTimestamp > 0) {
        return Math.round((this.endRecordingTimestamp - this.startRecordingTimestamp) / 1000 * 10) / 10;
      }
      return null;
    }
  }, {
    key: "hasUrl",
    get: function get() {
      return (0, _utils.isPresent)(this.url);
    }
  }, {
    key: "unselectedInputType",
    get: function get() {
      return (0, _utils.isBlank)(this.inputType);
    }
  }, {
    key: "hasMessageInput",
    get: function get() {
      return (0, _utils.isPresent)(this.messageInput);
    }
  }, {
    key: "videoActiveInput",
    get: function get() {
      return this.inputType === 'video';
    }
  }, {
    key: "audioActiveInput",
    get: function get() {
      return this.inputType === 'audio';
    }
  }, {
    key: "textActiveInput",
    get: function get() {
      return this.inputType === 'text';
    }
  }, {
    key: "recordingActiveInput",
    get: function get() {
      return this.audioActiveInput || this.videoActiveInput;
    }
  }, {
    key: "durationString",
    get: function get() {
      return "".concat(this.duration, "s");
    }
  }, {
    key: "timeDisplay",
    get: function get() {
      var divisorMinutes = this.secondsElapsed % (60 * 60);
      var minutes = Math.floor(divisorMinutes / 60);
      var divisorSeconds = divisorMinutes % 60;
      var seconds = Math.ceil(divisorSeconds);
      return "".concat(minutes < 10 ? 0 : '').concat(minutes, ":").concat(seconds < 10 ? 0 : '').concat(seconds);
    }
  }]);
}(), _descriptor = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "isRecording", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "mediaType", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 'audio';
  }
}), _descriptor3 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "audioLevel", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor4 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "maxAudioLevel", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor5 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "secondsElapsed", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor6 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "startRecordingTimestamp", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor7 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "endRecordingTimestamp", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor8 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "startPlayingTimestamp", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor9 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "pausePlayingTimestamp", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor0 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "playing", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor1 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "initialPlayHasFinished", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor10 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "currentTime", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor11 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "url", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor12 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "durationFromDatabase", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor13 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "autoPlay", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor14 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "hasFinishedRecording", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor15 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "canRecord", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor16 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "inputType", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor17 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "messageInput", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor18 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "caretPosition", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "normalizedAudioLevel", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "normalizedAudioLevel"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "duration", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "duration"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "hasUrl", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasUrl"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "unselectedInputType", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "unselectedInputType"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "hasMessageInput", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasMessageInput"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "videoActiveInput", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "videoActiveInput"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "audioActiveInput", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "audioActiveInput"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "textActiveInput", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "textActiveInput"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "recordingActiveInput", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "recordingActiveInput"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "durationString", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "durationString"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "timeDisplay", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "timeDisplay"), _class.prototype), _class);
var _default = exports["default"] = BaseUserInputStore;